/**
 * **************************************************************
 * Popup image make it decorative
 * ************************************************************
 **/

(function () {
  const selector = ".needsclick .kl-private-reset-css-Xuajs1 img";

  function removeAlt() {
    const images = document.querySelectorAll(selector);
    if (images.length > 0) {
      images[images.length - 1].setAttribute("alt","");
      observer.disconnect(); // stop observing once done
    }
  }

  const observer = new MutationObserver(removeAlt);
  observer.observe(document.body, { childList: true, subtree: true });

  // run once in case element already exists
  removeAlt();
})();


/**
 * *********************************************************************
 * Select "#MainContent" Skiplink, and highlight when focus received 
 * *********************************************************************
 **/

const skipLinks = document.querySelectorAll('a[href="#MainContent"]');

skipLinks.forEach(link => {
  // Focus in
  link.addEventListener("focus", () => {
    link.classList.remove("visually-hidden");
  });

  // Focus out
  link.addEventListener("blur", () => {
    link.classList.add("visually-hidden");
  });
});

/**
 * *********************************************************************
 * Access Search funcotinality with keyboard 
 * *********************************************************************
 **/

const element = document.querySelector(
  ".search_details.search_details--popup.header--icon-border"
);

if (element) {
  element.addEventListener("keydown", (event) => {
    if (event.key === "Enter" || event.key === " ") {
         if (element && element.hasAttribute("open")) {
            return;
         }
      event.preventDefault(); // prevent page scroll on Space
      element.querySelector('img').click();
      document.querySelectorAll(".search-modal__content form .search__input")[0].focus();
    }
    if (event.key === "Escape") {
        if (element && element.hasAttribute("open")) {
        element.focus();
        element.removeAttribute("open");
        document.querySelector("body").classList.remove("open_search_menu");
      }
    }
  });
}

/**
 * **************************************************************
 * fix the non interactive review stars
 * ************************************************************
 **/
document.addEventListener("DOMContentLoaded", function () {
    const intervalId = setInterval(function () {
      const slides = document.querySelectorAll('.jdgm-prev-badge__stars');
      if (slides.length > 0) {
        slides.forEach(slide => {
            slide.removeAttribute('role');
            slide.setAttribute('tabindex',"-1");
          });
          // Stop the interval after execution
          clearInterval(intervalId);
      }
    }, 10000);
});



/**
 * **************************************************************
 * Fix interactive elements hidden on product cards
 * + Works for runtime-added products (pagination/infinite scroll)
 * **************************************************************
 */

(function () {
  let isKeyboardUser = false;

  const VISIBLE_SELECTORS = ".card-product__group.group-right, .card-action";
  const STARS_SELECTOR = ".slick-initialized .slick-slide .jdgm-prev-badge__stars";

  // ----- Input method detection -----
  document.addEventListener("keydown", (e) => {
    const keys = ["Tab", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
    if (keys.includes(e.key)) isKeyboardUser = true;
  });

  document.addEventListener("mousedown", () => {
    isKeyboardUser = false;
  });

  // ----- Apply fixes -----
  const makeVisible = (root = document) => {
    root.querySelectorAll(VISIBLE_SELECTORS).forEach((el) => {
      el.style.setProperty("visibility", "visible", "important");
      el.style.setProperty("transform", "none", "important");
      el.style.setProperty("opacity", "1", "important");
    });
  };

  const fixStars = (root = document) => {
    root.querySelectorAll(STARS_SELECTOR).forEach((el) => {
      el.removeAttribute("role");
    });
  };

  // Run once on load for existing content
  const init = () => {
    makeVisible(document);
    fixStars(document);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // ----- Focus behavior for keyboard users (lightweight) -----
  // Instead of styling ALL cards on every focus move, style only the nearest product card
  document.addEventListener("focusin", (e) => {
    if (!isKeyboardUser) return;

    // Try to scope to the product card/item that received focus
    const cardRoot =
      e.target.closest(".product, .product-item, .card, li.product") || document;

    makeVisible(cardRoot);
    fixStars(cardRoot);
  });

  // ----- MutationObserver: fix runtime-added products -----
  // Observe the product grid and pagination area (in case Slick/Judge.me updates there too)
  const targets = [
    document.querySelector("#main-collection-product-grid"),
    document.querySelector(".pagination-wrapper")
  ].filter(Boolean);

  if (targets.length) {
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type !== "childList" || !m.addedNodes.length) continue;

        m.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;

          // Apply fixes to the added subtree only (fast)
          makeVisible(node);
          fixStars(node);
        });
      }
    });

    targets.forEach((t) => observer.observe(t, { childList: true, subtree: true }));
  }
})();

 /**
 * *****************************************************************************************
 * Fix the issue:  Move focus to newaly added review when pagination used
 * *****************************************************************************************
 **/
(() => {
  const BODY_SEL = ".jdgm-rev-widg__body";
  const REVIEWS_SEL = ".jdgm-rev-widg__reviews";
  const PAGE_BTN_SEL = ".jdgm-paginate__page";

  const FOCUSABLE_SEL =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  let userActivatedPagination = false;
  let activationTs = 0;

  const getBody = () => document.querySelector(BODY_SEL);
  const getReviews = () => document.querySelector(`${BODY_SEL} ${REVIEWS_SEL}`);

  const getFirstFocusTarget = (reviewsEl) => {
    if (!reviewsEl) return null;

    // Best: first review rating (already tabindex="0" in your markup)
    const rating = reviewsEl.querySelector(".jdgm-rev__rating[tabindex]");
    if (rating) return rating;

    // Next: any focusable element inside reviews
    const focusable = reviewsEl.querySelector(FOCUSABLE_SEL);
    if (focusable) return focusable;

    // Fallback: reviews container itself
    return reviewsEl;
  };

  const focusAndScroll_VO = (el) => {
    if (!el) return;

    // Ensure focusable if it's a container
    if (!el.matches(FOCUSABLE_SEL) && !el.hasAttribute("tabindex")) {
      el.setAttribute("tabindex", "-1");
    }

    // VoiceOver often behaves better when we scroll first, then focus
    // Keep delays short so it still feels tied to the user action.
    setTimeout(() => {
      try {
        el.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      } catch (_) {}

      setTimeout(() => {
        try {
          el.focus({ preventScroll: true });
        } catch (e) {
          try { el.focus(); } catch (_) {}
        }
      }, 80);
    }, 120);
  };

  // 1) Mark ONLY user pagination activation (click or keyboard activation)
  const markActivation = (el) => {
    if (!el.closest(BODY_SEL)) return;
    userActivatedPagination = true;
    activationTs = Date.now();
  };

  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest(PAGE_BTN_SEL);
      if (btn) markActivation(btn);
    },
    true
  );

  // For keyboard users (and macOS VO sometimes), capture Enter/Space activation too
  document.addEventListener(
    "keydown",
    (e) => {
      if (e.key !== "Enter" && e.key !== " ") return;
      const btn = e.target.closest?.(PAGE_BTN_SEL);
      if (btn) markActivation(btn);
    },
    true
  );

  // 2) Attach observer after widget exists (runtime loaded)
  const attachObserver = () => {
    const bodyEl = getBody();
    if (!bodyEl) return false;

    let debounceTimer = null;

    const observer = new MutationObserver(() => {
      if (!userActivatedPagination) return;

      // If this mutation happens long after activation, ignore (prevents random focus jumps)
      if (Date.now() - activationTs > 4000) {
        userActivatedPagination = false;
        return;
      }

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        const reviewsEl = getReviews();
        if (!reviewsEl) return;

        const target = getFirstFocusTarget(reviewsEl);
        focusAndScroll_VO(target);

        // Reset — run only once per user pagination action
        userActivatedPagination = false;
      }, 120);
    });

    observer.observe(bodyEl, { childList: true, subtree: true });
    return true;
  };

  const poll = setInterval(() => {
    if (attachObserver()) clearInterval(poll);
  }, 300);
})();


 /**
 * *****************************************************************************************
 * Fix the trap keyboard focus within the product “Quick View” popup modal when it is open. 
 * *****************************************************************************************
 **/
const OPEN_CLASS = 'quick-view-show';
const POPUP_SEL = '#halo-quick-view-popup';
const CLOSE_SEL = '.halo-popup-close';

let lastFocused = null;
let isOpen = false;

const focusableSel = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled]):not([type="hidden"])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])'
].join(',');

const popupEl = () => document.querySelector(POPUP_SEL);

const getFocusable = () => {
  const p = popupEl();
  if (!p) return [];
  return [...p.querySelectorAll(focusableSel)]
    .filter(el => el.offsetParent !== null); // visible
};

const focusCloseOrFirst = () => {
  const p = popupEl();
  if (!p) return;

  const closeBtn = p.querySelector(CLOSE_SEL);
  const focusables = getFocusable();
  const first = focusables[0];

  // Prefer close button
  if (closeBtn && closeBtn.offsetParent !== null) {
    closeBtn.focus();
  } else if (first) {
    first.focus();
  } else {
    // fallback: focus popup itself
    p.setAttribute('tabindex', '-1');
    p.focus();
  }
};

// Wait until close button exists/visible (handles dynamic injection)
const focusWhenReady = (tries = 0) => {
  if (!document.body.classList.contains(OPEN_CLASS)) return;

  const p = popupEl();
  const closeBtn = p && p.querySelector(CLOSE_SEL);

  if (p && closeBtn && closeBtn.offsetParent !== null) {
    closeBtn.focus();
    return;
  }

  // Try again shortly (up to ~1s)
  if (tries < 30) requestAnimationFrame(() => focusWhenReady(tries + 1));
};

const onKeydown = (e) => {
  if (!isOpen) return;

  const p = popupEl();
  if (!p) return;

  // ESC closes via your existing logic
  if (e.key === 'Escape') {
    const closeBtn = p.querySelector(CLOSE_SEL);
    if (closeBtn) closeBtn.click();
    return;
  }

  if (e.key !== 'Tab') return;

  const focusables = getFocusable();
  if (!focusables.length) {
    e.preventDefault();
    focusCloseOrFirst();
    return;
  }

  const first = focusables[0];
  const last = focusables[focusables.length - 1];

  // If focus is not inside popup, bring it back to first
  if (!p.contains(document.activeElement)) {
    e.preventDefault();
    first.focus();
    return;
  }

  // Trap loop:
  // - Tab on last => first
  // - Shift+Tab on first => last
  if (!e.shiftKey && document.activeElement === last) {
    e.preventDefault();
    first.focus();
  } else if (e.shiftKey && document.activeElement === first) {
    e.preventDefault();
    last.focus();
  }
};

// If focus moves outside (mouse click / script / etc.), force it back in
const onFocusIn = (e) => {
  if (!isOpen) return;

  const p = popupEl();
  if (!p) return;

  if (!p.contains(e.target)) {
    // Reset to first focusable (or close button)
    focusCloseOrFirst();
  }
};

const open = () => {
  if (isOpen) return;
  isOpen = true;

  lastFocused = document.activeElement;

  const p = popupEl();
  if (p) {
    p.setAttribute('role', 'dialog');
    p.setAttribute('aria-modal', 'true');
  }

  document.addEventListener('keydown', onKeydown, true);
  document.addEventListener('focusin', onFocusIn, true);

  // focus close button when ready (dynamic content safe)
  focusWhenReady();
};

const close = () => {
  if (!isOpen) return;
  isOpen = false;

  document.removeEventListener('keydown', onKeydown, true);
  document.removeEventListener('focusin', onFocusIn, true);

  if (lastFocused && typeof lastFocused.focus === 'function') {
    lastFocused.focus();
  }
  lastFocused = null;
};

// Detect open/close via body class changes
new MutationObserver(() => {
  const nowOpen = document.body.classList.contains(OPEN_CLASS);
  if (nowOpen) open();
  else close();
}).observe(document.body, { attributes: true, attributeFilter: ['class'] });

// If already open on load
if (document.body.classList.contains(OPEN_CLASS)) open();

/**
 * **************************************************************
 * fix the category sidebar drodown menu
 * **************************************************************
 **/

document.addEventListener('DOMContentLoaded', function () {
  const dropdownItems = document.querySelectorAll('.sdbmenu-menu__item.has-dropdown > .sdbmenu-menu__link:not(.site-nav-mobile .sdbmenu-menu__link)');

  dropdownItems.forEach(item => {
    // Avoid adding the button twice
   
    let buttonHTML = `
    <button type="button"
      class="btn dropdown-toggle dropdown-toggle-split"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      aria-label="Toggle submenu of `+item.textContent.trim() +`">
      <i class="icon icon-tr" aria-hidden="true">
        <svg viewBox="0 0 12 8">
          <path d="M6 6.174l5.313-4.96.23-.214.457.427-.23.214-5.51 5.146L6.03 7 6 6.972 5.97 7l-.23-.214L.23 1.64 0 1.428.458 1l.23.214L6 6.174z"
            stroke-linecap="square"
            fill-rule="evenodd">
          </path>
        </svg>
      </i>
      <span class="visually-hidden">Toggle Dropdown</span>
    </button>
  `;

    if (!item.nextElementSibling?.classList.contains('dropdown-toggle-split')) {
      item.insertAdjacentHTML('afterend', buttonHTML);
    }
    item.querySelector(".icon-arrow").style.display="none";
  });


  document.addEventListener('click', function (e) {
    const button = e.target.closest(
      '.sdbmenu-menu .dropdown-toggle-split'
    );
    if (!button) return;
    const isExpanded = button.getAttribute('aria-expanded') === 'false';
    if (isExpanded) {
        button.setAttribute("aria-expanded",true);
        button.parentElement.querySelector('.sdbmenu-menu--dropdown.list-unstyled').style.display= "block";      
    }
    else{
      
        button.setAttribute("aria-expanded",false);
        button.parentElement.querySelector('.sdbmenu-menu--dropdown.list-unstyled').style.display= "none";      
    }
  });
});

/**
 * **************************************************************
 * fix the pricing slider on category page
 * ************************************************************
 **/
document.addEventListener('DOMContentLoaded', function () {
  const button = document.querySelector('.sibarbarBlock-filter-price button');

  if (!button) return;

  button.addEventListener('click', function () {
    const isExpanded = button.getAttribute('aria-expanded') === 'false';
    console.log(button.getAttribute('aria-expanded'));
    if (isExpanded) {
      button.setAttribute('aria-expanded', true);
    }
    else{
      button.setAttribute('aria-expanded', false);
    }
  });
});

/**
 * **********************************************************************************************************************************
 * fix the issue: “View as list”, “View as grid” controls are not keyboard operable
 * ***********************************************************************************************************************************
 **/
document.querySelectorAll(
    '.toolbar-item.toolbar-viewAs .toolbar-icon'
).forEach(icon => {
    icon.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.click();
        }
    });
});

/**
 * ***********************************************************************************************
 * fix the issue: “Show number of products” and “Sort by” dropdown items are not keyboard operable
 * ***********************************************************************************************
 **/
document.querySelectorAll('.toolbar-dropdown').forEach(dropdown => {
    const toggle = dropdown.querySelector('.label-tab');
    const menu = dropdown.querySelector('.dropdown-menu');

    const openDropdown = () => {
        dropdown.classList.add('open');
        toggle.setAttribute('aria-expanded', 'true');
    };

    const closeDropdown = () => {
        dropdown.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');               
    };

    const isOpen = () => dropdown.classList.contains('open');

    // Toggle on click
    toggle.addEventListener('click', () => {
        e.preventDefault();
        isOpen() ? closeDropdown() : openDropdown();
    });

    // Toggle on Enter / Space
    toggle.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            isOpen() ? closeDropdown() : openDropdown();
        }
    });

    // Close on Esc (from anywhere inside dropdown)
    dropdown.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            e.preventDefault();
            closeDropdown();
            toggle.focus(); // return focus to trigger
        }
    });

    // Close when focus moves outside
    dropdown.addEventListener('focusout', e => {
        if (!dropdown.contains(e.relatedTarget)) {
            closeDropdown();
        }
    });
});



/**
 * ***********************************************************************************************
 * fix the issue: When “Sort by” operation performed, loader doesn't notify by scren reader 
 * ***********************************************************************************************
 **/
var loader_flag = 0;
const body = document.body;
const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
        if (mutation.attributeName === 'class') {
            if (body.classList.contains('has-halo-loader')) {
                document.querySelector("#when-loader-visible").textContent = "loading";
                loader_flag = 1;
            } else if (loader_flag) {
                document.querySelector("#when-loader-visible").textContent = "Sorted by: "+document.querySelector(".toolbar-dropdown.filter-sortby .label-text").textContent;
                document.querySelector(".toolbar-dropdown.filter-sortby .label-tab").focus();
                loader_flag = 0;
            }
        }
    });
});

observer.observe(body, {
    attributes: true,
    attributeFilter: ['class']
});


/**
 * *********************************************************************************************************
 * fix the issue: Screen reader users are not informed which page is currently selected 
 * *********************************************************************************************************
 **/
    setInterval(function(){
      document.querySelectorAll('.jdgm-paginate__page.jdgm-curt')
      .forEach(el => {
        el.setAttribute('aria-current', 'page');
      });
      document.querySelectorAll('.jdgm-paginate__page.jdgm-paginate__first-page')
      .forEach(el => {
        el.setAttribute('aria-label', 'first page');
      });
      document.querySelectorAll('.jdgm-paginate__page.jdgm-paginate__last-page')
      .forEach(el => {
        el.setAttribute('aria-label', 'last page');
      });
      document.querySelectorAll('.jdgm-paginate__page.jdgm-paginate__next-page')
      .forEach(el => {
        el.setAttribute('aria-label', 'next page');
      });
      document.querySelectorAll('.jdgm-paginate__page.jdgm-paginate__prev-page')
      .forEach(el => {
        el.setAttribute('aria-label', 'previous page');
      });
    }, 2000);

    
/**
 * *********************************************************
 * fix the issue: Add missing landmark for review pagination 
 * *********************************************************
 **/
    setInterval(() => {
      const paginate = document.querySelector('.jdgm-paginate');

      if (!paginate) return;

      // Do nothing if already wrapped
      if (paginate.parentElement?.tagName === 'NAV') return;

      const nav = document.createElement('nav');
      nav.setAttribute('aria-label', 'Reviews pagination');

      paginate.parentNode.insertBefore(nav, paginate);
      nav.appendChild(paginate);
    }, 2000);

/**
 * *******************************************************************
 * fix the issue: Heading level for multi-recipient-checkout-app-block
 * *******************************************************************
 **/

  const intervalId = setInterval(() => {
  const container = document.getElementById(
    'multi-recipient-checkout-app-block'
  );

  if (!container) return;

  const h4Elements = container.querySelectorAll('h4');

  if (!h4Elements.length) return;

  h4Elements.forEach(h4 => {
    const h3 = document.createElement('h3');

    // copy attributes
    [...h4.attributes].forEach(attr =>
      h3.setAttribute(attr.name, attr.value)
    );

    // copy content
    h3.innerHTML = h4.innerHTML;

    // replace h4 with h3
    h4.replaceWith(h3);
  });

  // stop interval after successful update
  clearInterval(intervalId);
}, 300);




/**
 * *************************************************************************************
 * fix the issue: keyboard focus is unexpectedly moved when quantity change on cart page
 * *************************************************************************************
 **/

// 1. When user changes quantity, save the field id in localStorage
document.addEventListener('change', function (e) {
  const input = e.target;
  if (input.matches('.cart-item-qty-input, input[name="quantity"]')) {
    localStorage.setItem('shopifyLastQtyId', input.id);
  }
});

// 2. On page load, restore focus to the last updated visible quantity field
document.addEventListener('DOMContentLoaded', function () {
  const target =
    document.querySelector('form[action^="/cart"]') ||
    document.querySelector('.cart') ||
    document.body;

  if (!target) return;

  let restorePending = false;

  const restoreFocus = () => {
    const fieldId = localStorage.getItem('shopifyLastQtyId');
    if (!fieldId) return;

    const inputs = document.querySelectorAll(`#${CSS.escape(fieldId)}`);
    const visibleInput = Array.from(inputs).find(
      el => el.offsetParent !== null
    );

    if (visibleInput) {
      visibleInput.focus();
      visibleInput.select();
      visibleInput.scrollIntoView({ block: 'center' });

      localStorage.removeItem('shopifyLastQtyId');
      restorePending = false;
    }

    
  };

  const observer = new MutationObserver(() => {
    // Throttle multiple DOM mutations
    if (!restorePending && localStorage.getItem('shopifyLastQtyId')) {
      restorePending = true;
      requestAnimationFrame(restoreFocus);
    }
  });

  observer.observe(target, {
    childList: true,
    subtree: true
  });
});

/**
 * ********************************************************************************************************
 * fix the issue: When the Remove product no confirmation or status message is announced by screen readers
 * ********************************************************************************************************
 **/
document.addEventListener('DOMContentLoaded', function () {
 if (!document.getElementById('cart-status-message')) {
    const liveRegion = document.createElement('div');
    liveRegion.id = 'cart-status-message';
    liveRegion.className = 'visually-hidden';
    liveRegion.setAttribute('role', 'status');
    liveRegion.setAttribute('aria-live', 'assertive');
    liveRegion.setAttribute('aria-atomic', 'true');
    document.body.appendChild(liveRegion);
  }
  
   const cartContainer = document.getElementById('main-cart-items');
  if (!cartContainer) return;

  const liveRegion = document.getElementById('cart-status-message');
  if (!liveRegion) return;

  let previousItems = cartContainer.querySelectorAll('.cart-item');

  const observer = new MutationObserver(() => {
    const currentItems = cartContainer.querySelectorAll('.cart-item');

    // Compare previous and current items to detect removal
    const removedItems = [...previousItems].filter(
      prev => ![...currentItems].some(curr => curr.dataset.line === prev.dataset.line)
    );

    if (removedItems.length > 0) {
      removedItems.forEach(item => {
        const name = item.querySelector('.cart-item__name')?.textContent?.trim() || 'Item';
        updateLiveRegion(`${name} removed from cart`);
      });
    }

    // Save current items for next comparison
    previousItems = currentItems;
  });

  observer.observe(cartContainer, { childList: true, subtree: true });

  function updateLiveRegion(message) {
    liveRegion.textContent = '';
    setTimeout(() => {
      liveRegion.textContent = message;
    }, 100);
  }
});

/**
 * ********************************************************************************
 * fix the issue: “Select a Shipping or Store Pickup Date” options 
 *                - selection behaviour unclear to screen reader and keyboard users
 * ********************************************************************************
 **/
// Function to initialize radiogroup behavior
function initCheckoutMethods(container) {
  const items = Array.from(container.querySelectorAll('.checkoutMethod'));
  const labelId = 'shipping-or-store-pickup-date'; // Replace with your actual label ID

  // Set container attributes
  container.setAttribute('role', 'radiogroup');
  container.setAttribute('aria-labelledby', labelId);

  // Initialize each item
  items.forEach((item, index) => {
    // Skip if already initialized
    if (item.getAttribute('role') === 'radio') return;

    item.setAttribute('role', 'radio');
    item.setAttribute('aria-checked', item.classList.contains('active') ? 'true' : 'false');
    item.tabIndex = item.classList.contains('active') ? 0 : -1;

    // Click handler
    item.addEventListener('click', () => selectItem(index));

    // Keyboard navigation
    item.addEventListener('keydown', (e) => {
      let newIndex = index;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        newIndex = (index + 1) % items.length;
        e.preventDefault();
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        newIndex = (index - 1 + items.length) % items.length;
        e.preventDefault();
      } else if (e.key === ' ' || e.key === 'Enter') {
        selectItem(index);
        e.preventDefault();
        return;
      }

      if (newIndex !== index) {
        selectItem(newIndex);
      }
    });
  });

  // Function to select an item
  function selectItem(index) {
    items.forEach((item, i) => {
      const isSelected = i === index;
      item.classList.toggle('active', isSelected);
      item.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      item.tabIndex = isSelected ? 0 : -1;

      if (isSelected) item.focus();
    });
  }
}

// Observe the document for dynamically added checkoutMethodsContainer
const observer1 = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType !== 1) return; // Skip non-element nodes

      // If the container itself is added
      if (node.matches && node.matches('.checkoutMethodsContainer')) {
        initCheckoutMethods(node);
      }

      // Or if children inside container are added
      const containers = node.querySelectorAll && node.querySelectorAll('.checkoutMethodsContainer');
      containers && containers.forEach(initCheckoutMethods);
    });
  });
});

// Start observing the body
observer1.observe(document.body, { childList: true, subtree: true });

// Initialize any existing containers on page load
document.querySelectorAll('.checkoutMethodsContainer').forEach(initCheckoutMethods);

/**
 * *****************************************************************
 * fix the issue: Remove Redundant alt text
 * *****************************************************************
 **/

(function () {

  const TARGET_SELECTOR =
    '.s2m-checkout-product-card .s2m-checkout-card-product-image img';

  // Remove alt from existing images
  function removeAlt() {
    document.querySelectorAll(TARGET_SELECTOR).forEach(img => {
      if (img.hasAttribute('alt')) {
        img.removeAttribute('alt');
        console.log('alt removed from image', img);
      }
    });
  }

  // Initial run (in case some images already exist)
  removeAlt();

  //Observe runtime DOM changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;

        // Direct match
        if (node.matches && node.matches(TARGET_SELECTOR)) {
          node.removeAttribute('alt');
        }

        // Child match
        if (node.querySelectorAll) {
          node.querySelectorAll(TARGET_SELECTOR).forEach(img => {
            img.removeAttribute('alt');
          });
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();


/**
 * *****************************************************************
 * fix the issue: Remove empty <u> tag
 * *****************************************************************
 **/
document.querySelectorAll('u').forEach(u =>
  !u.textContent.trim() && !u.children.length && u.remove()
);



/**
 * *****************************************************************
 * fix the issue: set img decorative
 * *****************************************************************
 **/ 
const img = document.querySelector('.needsclick.kl-private-reset-css-Xuajs1 img');
if (img) {
  img.setAttribute('alt', '');
  img.setAttribute('style', 'display:none');
} else {
  const mo = new MutationObserver((_, obs) => {
    const img = document.querySelector('.needsclick.kl-private-reset-css-Xuajs1 img');
    if (img) {
      img.setAttribute('alt', '');
      img.setAttribute('style', 'display:none');
      //obs.disconnect();
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
}
/**
 * *****************************************************************
 * fix the issue: make the label with full text for dynamic elements
 * *****************************************************************
 **/


(function () {
  function updateQtyLabel() {
    const labels = document.querySelectorAll('label.s2m-checkout-form-label');
    labels.forEach(label => {
      if (label.textContent.trim() === 'Qty') {
        label.textContent = 'Quantity';
      }
    });
  }

  // Run once in case it already exists
  updateQtyLabel();

  // Observe DOM changes
  const observer = new MutationObserver(updateQtyLabel);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

/**
 * *********************************************************************************************************
 * fix the issue: When show more button add more items focus set to new items and set text for screen reader
 * *********************************************************************************************************
 **
*/
const focusAndScroll = (el) => {
  if (!el) return;

  // Make programmatically focusable if needed
  if (
    !el.matches(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    ) &&
    !el.hasAttribute("tabindex")
  ) {
    el.setAttribute("tabindex", "-1");
  }

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      try {
        el.focus({ preventScroll: true }); // prevent browser auto scroll
      } catch {
        el.focus();
      }

      // Manual scroll – more reliable for SR users
      el.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    });
  });
};
(() => {
  const grid = document.querySelector("ul#main-collection-product-grid");
  if (!grid) return;

  // Gate: only announce when user clicked "Show more"
  let loadMoreClicked = false;
  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest(".pagination-wrapper.text-center a.button.button--secondary");
      if (btn) loadMoreClicked = true;
    },
    true
  );

  // Live region (assertive + reliable)
  const LIVE_ID = "plp-added-products-status";
  if (!document.getElementById(LIVE_ID)) {
    document.body.insertAdjacentHTML(
      "beforeend",
      `<div id="${LIVE_ID}" role="alert" aria-live="assertive" aria-atomic="true" class="visually-hidden"></div>`
    );
  }
  const statusEl = document.getElementById(LIVE_ID);

  // Make sure visually-hidden is NOT display:none in CSS

  // Track existing LI.product nodes
  const seen = new Set(Array.from(grid.querySelectorAll("li.product")));

  let timer = null;
  let pending = [];
  let announceSeq = 0;

  const FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  const getBestFocusTarget = (li) =>
    li.querySelector("a.card-title") ||
    li.querySelector("a.product-item__btn") ||
    li.querySelector(FOCUSABLE) ||
    li;

  const moveFocus = (el) => {
    if (!el) return;
    if (!el.matches(FOCUSABLE) && !el.hasAttribute("tabindex")) el.setAttribute("tabindex", "-1");

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        try {
          el.focus({ preventScroll: false });
        } catch {
          el.focus();
        }
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  };

  // ✅ Reliable announcement helper
  const announce = (msg) => {
    announceSeq += 1;

    // Clear, then set with a short delay so SR detects a fresh change
    statusEl.textContent = "";
    setTimeout(() => {
      // Add a tiny “hidden” uniqueness marker so repeated messages still announce
      statusEl.innerHTML = `${msg} <span class="visually-hidden">(${announceSeq})</span>`;
    }, 120);
  };

  const observer = new MutationObserver((mutations) => {
    const newlyFound = [];

    for (const m of mutations) {
      if (m.type !== "childList" || !m.addedNodes.length) continue;

      m.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;

        // Only count LI.product added directly under the grid
        if (node.matches?.("li.product") && !seen.has(node)) {
          seen.add(node);
          newlyFound.push(node);
        }
      });
    }

    if (!newlyFound.length) return;

    pending = pending.concat(newlyFound);

    clearTimeout(timer);
    timer = setTimeout(() => {
      const count = pending.length;
      const firstNew = pending[0];
      pending = [];

      // ✅ Only announce after user click "Show more"
      if (loadMoreClicked) {
        announce(`${count} new products added.`);
        //moveFocus(getBestFocusTarget(firstNew));
        focusAndScroll(getBestFocusTarget(firstNew));
        loadMoreClicked = false;
      }
    }, 200);
  });

  // Important: subtree:false avoids noise from internal updates (Judge.me etc.)
  observer.observe(grid, { childList: true, subtree: false });
})();




/**
 * **************************************************************
 * fix the menu as per accessibility guideline 
 * ************************************************************
 **/
let subMenuToggleBtn =
  '<button type="button" class="btn dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" aria-label="Toggle submenu"><i class="icon icon-tr" aria-hidden="true"><svg viewBox="0 0 12 8"><path d="M6 6.174l5.313-4.96.23-.214.457.427-.23.214-5.51 5.146L6.03 7 6 6.972 5.97 7l-.23-.214L.23 1.64 0 1.428.458 1l.23.214L6 6.174z" stroke-linecap="square" fill-rule="evenodd"></path></svg></i><span class="visually-hidden">Toggle Dropdown</button></span>';

document.querySelectorAll("#HeaderNavigation .menu-lv-item.dropdown > .link").forEach(function (element) {
  element.insertAdjacentHTML("afterend", subMenuToggleBtn);
});

document.querySelectorAll("#HeaderNavigation .menu-lv-item.dropdown .site-nav-list-dropdown > .header__submenu").forEach(function (element) {
  element.insertAdjacentHTML("beforebegin", subMenuToggleBtn);
});

document.addEventListener("DOMContentLoaded", function () {

  document
  .querySelectorAll('.shopify-section-group-header-group[aria-live]')
  .forEach(el => el.removeAttribute('aria-live'));
 
  document.querySelector("#HeaderNavigation").addEventListener("keyup", function (e) {
    // Press Esc Key
    if (e.key === "Escape") {

        const searchPopup = document.querySelector(
        ".search_details.search_details--popup.header--icon-border"
        );

        // Do NOT proceed if popup is open
        if (searchPopup && searchPopup.hasAttribute("open")) {
            searchPopup.querySelector('img').focus();
        return;
        }

      const dropdownToggles = document.querySelectorAll(".dropdown-toggle");
      const submenu = document.querySelector("#HeaderNavigation .menu-lv-item.dropdown > .header__submenu");

      dropdownToggles.forEach(function (button) {
        const expanded = button.getAttribute("aria-expanded") === "true";

        if (expanded) {
          button.setAttribute("aria-expanded", "false");
          if (button.classList.contains("menuOpen")) {
            button.classList.remove("menuOpen");
          }
        }
      });

      submenu.style.visibility = "";
      submenu.style.opacity = "";

      const firstDropdownToggle = document.querySelector(".dropdown-toggle");
      if (firstDropdownToggle) {
        firstDropdownToggle.focus();
      }
    }
  });

  if (window.matchMedia("(min-width: 1024px)").matches) {
    var subMenus = document.querySelectorAll("#HeaderNavigation .menu-lv-item.dropdown > .header__submenu, #HeaderNavigation .menu-lv-item.dropdown .site-nav-list-dropdown > .header__submenu");
    
    subMenus.forEach(function (submenu) {
      submenu.addEventListener("focusout", function (event) {
        if (!submenu.contains(event.relatedTarget)) {
          submenu.style.display = "";
          submenu.style.visibility = "";
          submenu.style.opacity = "";

          if (submenu.classList.contains("d-block")) {
            submenu.classList.remove("d-block");
          }

          const dropdownToggles = document.querySelectorAll(".dropdown-toggle");
          dropdownToggles.forEach(function (button) {
            if (button.getAttribute("aria-expanded") === "true") {
              button.setAttribute("aria-expanded", "false");
              if (button.classList.contains("menuOpen")) {
                button.classList.remove("menuOpen");
              }
            }
          });
        }
      });
    });
  }

  function reattachEventListeners(target) {
    const dropdownToggles = target.querySelectorAll(".dropdown-toggle");

    dropdownToggles.forEach((button) => {
      const ariaLabel = button.getAttribute("aria-label");

      if (ariaLabel) {
        const siblingLinks = button.parentElement.querySelectorAll("#HeaderNavigation .link");

        if (siblingLinks.length !== 0) {
          const subMenuTitle = siblingLinks[0].textContent.trim().toLowerCase();
          button.setAttribute("aria-label", ariaLabel.replace("submenu", "submenu of " + subMenuTitle));
        }
      }

      button.addEventListener("click", function (e) {
        e.stopPropagation();

        const submenu = button.parentElement.querySelector(
          "#HeaderNavigation .menu-lv-item.dropdown > .header__submenu, #HeaderNavigation .menu-lv-item.dropdown .site-nav-list-dropdown > .header__submenu"
        );
        const isVisible = button.getAttribute("aria-expanded") === "true" || button.classList.contains("menuOpen");

        submenu.style.display = isVisible ? "" : "block";
        submenu.style.opacity = isVisible ? "" : "1";
        submenu.style.visibility = isVisible ? "" : "visible";

        if (isVisible) {
          submenu.classList.remove("d-block");
        } else {
          submenu.classList.add("d-block");
        }

        const ariaExpanded = isVisible ? "false" : "true";
        button.setAttribute("aria-expanded", ariaExpanded);

        if (!isVisible) {
          button.classList.add("menuOpen");
          if (window.matchMedia("(min-width: 1024px)").matches) {
            const firstFocusableElement = submenu.querySelector("a, button");
            if (firstFocusableElement) {
              firstFocusableElement.focus();
            }
          } else {
            setTimeout(function () {
              button.focus();
            }, 250);
          }
        } else {
          button.classList.remove("menuOpen");
          if (window.matchMedia("(max-width: 1023px)").matches) {
            setTimeout(function () {
              button.focus();
            }, 250);
          }
        }
      });
    });
  }

  const existingNavPagesLists = document.querySelectorAll("#HeaderNavigation nav > .list-menu");
  existingNavPagesLists.forEach(reattachEventListeners);
});  



/*
* **********************************************************
* Fix the issue:  moblie menu as per accessiblity guideline 
* *********************************************************** 
*/
(() => {
  const BODY_OPEN_CLASS = 'menu_open';
  const TOGGLE_SEL = 'button.mobileMenu-toggle';
  const MENU_SEL = '#navigation-mobile';
  const TITLE_SEL = '#navigation-mobile .menu-heading-mobile .title';

  const FOCUSABLE_SEL = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  let trapActive = false;
  let lastToggle = null;
  let wasOpen = false;

  const isOpen = () => document.body.classList.contains(BODY_OPEN_CLASS);

  const isVisible = (el) => {
    if (!el) return false;
    const s = getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden') return false;
    return el.offsetParent !== null || s.position === 'fixed';
  };

  const getFocusable = (root) =>
    [...root.querySelectorAll(FOCUSABLE_SEL)].filter(isVisible);

  const setExpandedAttrs = () => {
    const toggle = document.querySelector(TOGGLE_SEL);
    if (!toggle) return;

    toggle.setAttribute('aria-controls', 'navigation-mobile');
    toggle.setAttribute('aria-expanded', isOpen() ? 'true' : 'false');
  };

  const focusIntoMenu = () => {
    const menu = document.querySelector(MENU_SEL);
    if (!menu) return;

    // Prefer focusing the "Menu" title, as you requested
    const title = document.querySelector(TITLE_SEL);
    if (title) {
      if (!title.hasAttribute('tabindex')) title.setAttribute('tabindex', '-1');

      // double rAF helps with Shopify animations / class toggles
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (isOpen() && isVisible(menu)) title.focus({ preventScroll: true });
        });
      });
      return;
    }

    // Fallback: first focusable item in menu
    const items = getFocusable(menu);
    if (items[0]) {
      requestAnimationFrame(() => items[0].focus({ preventScroll: true }));
    } else {
      // last fallback
      if (!menu.hasAttribute('tabindex')) menu.setAttribute('tabindex', '-1');
      requestAnimationFrame(() => menu.focus({ preventScroll: true }));
    }
  };

  const focusToggle = () => {
    const toggle = lastToggle || document.querySelector(TOGGLE_SEL);
    if (!toggle) return;
    requestAnimationFrame(() => toggle.focus({ preventScroll: true }));
  };

  const trap = (e) => {
    if (!trapActive) return;
    if (!isOpen()) return;
    if (e.key !== 'Tab') return;

    const menu = document.querySelector(MENU_SEL);
    if (!menu) return;

    // ✅ IMPORTANT: only trap when focus is already inside the menu
    const active = document.activeElement;
    if (!menu.contains(active)) return;

    const items = getFocusable(menu);
    if (!items.length) return;

    const first = items[0];
    const last = items[items.length - 1];

    if (e.shiftKey && active === first) {
      e.preventDefault();
      last.focus({ preventScroll: true });
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus({ preventScroll: true });
    }
  };

  const enableTrap = () => {
    if (trapActive) return;
    trapActive = true;
    document.addEventListener('keydown', trap, true);
  };

  const disableTrap = () => {
    if (!trapActive) return;
    trapActive = false;
    document.removeEventListener('keydown', trap, true);
  };

  const onOpen = () => {
    const toggle = document.querySelector(TOGGLE_SEL);
    if (toggle) lastToggle = toggle;

    setExpandedAttrs();
    enableTrap();
    focusIntoMenu();
  };

  const onClose = () => {
    setExpandedAttrs();
    disableTrap();
    focusToggle();
  };

  const sync = () => {
    setExpandedAttrs();

    const nowOpen = isOpen();
    if (nowOpen && !wasOpen) onOpen();
    if (!nowOpen && wasOpen) onClose();
    wasOpen = nowOpen;
  };

  // Observe body class changes
  const obs = new MutationObserver(sync);
  obs.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  // Initial run
  sync();
})();




/*
* ************************************************************************
* FIX THE ISSUE: search toggle button, keyboard and screen reader 
                  focus does not move into the search sidebar. 
* ************************************************************************
**/

(() => {
  const BODY_OPEN_CLASS = 'open_search_mobile';
  const SIDEBAR_SEL = '#search-form-mobile';
  const INPUT_ID = 'Search-In-Modal-Sidebar';

  // IMPORTANT: update selector to the actual opener if needed
  const OPENER_SEL = '[data-search-mobile], .header__icon--search, summary[data-search-mobile]';

  const FOCUSABLE_SEL = [
    'a[href]',
    'a[role="button"]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  let openerEl = null;
  let hiddenOutside = [];
  let trapBound = false;
  let focusGuardBound = false;

  const isOpen = () => document.body.classList.contains(BODY_OPEN_CLASS);
  const sidebar = () => document.querySelector(SIDEBAR_SEL);
  const input = () => document.getElementById(INPUT_ID);

  const isVisible = (el) => {
    if (!el) return false;
    const s = getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden') return false;
    return el.offsetParent !== null || s.position === 'fixed';
  };

  const getFocusable = (root) =>
    [...root.querySelectorAll(FOCUSABLE_SEL)].filter(isVisible);

  // iOS keyboard helper: click + focus (only works reliably inside user gesture)
  const focusInputPreferKeyboard = () => {
    const el = input();
    if (!el || !isVisible(el)) return;

    try { el.click(); } catch (_) {}
    el.focus(); // avoid preventScroll on iOS; it can reduce keyboard reliability
    try { el.setSelectionRange(el.value.length, el.value.length); } catch (_) {}
  };

  // fallback focus (after open)
  const focusInputFallback = () => {
    const el = input();
    const sb = sidebar();
    if (el && isVisible(el)) {
      el.focus({ preventScroll: true });
      return;
    }
    if (!sb) return;
    const items = getFocusable(sb);
    if (items[0]) items[0].focus({ preventScroll: true });
  };

  // --- VoiceOver containment: hide outside content from SR (and inert if supported) ---
  const setOutsideHidden = (on) => {
    const sb = sidebar();
    if (!sb) return;

    const parent = sb.parentElement || document.body;
    const siblings = [...parent.children].filter((el) => el !== sb);

    if (on) {
      hiddenOutside = [];
      siblings.forEach((el) => {
        const prev = el.getAttribute('aria-hidden');
        hiddenOutside.push({ el, prev });
        el.setAttribute('aria-hidden', 'true');
        try { if ('inert' in el) el.inert = true; } catch (_) {}
      });
    } else {
      hiddenOutside.forEach(({ el, prev }) => {
        if (!el || !document.contains(el)) return;
        if (prev === null) el.removeAttribute('aria-hidden');
        else el.setAttribute('aria-hidden', prev);
        try { if ('inert' in el) el.inert = false; } catch (_) {}
      });
      hiddenOutside = [];
    }
  };

  // --- focus trap (hardware keyboard) ---
  const trap = (e) => {
    if (!isOpen() || e.key !== 'Tab') return;
    const sb = sidebar();
    if (!sb) return;

    const items = getFocusable(sb);
    if (!items.length) return;

    const first = items[0];
    const last = items[items.length - 1];
    const active = document.activeElement;

    if (!sb.contains(active)) {
      e.preventDefault();
      first.focus({ preventScroll: true });
      return;
    }

    if (e.shiftKey && active === first) {
      e.preventDefault();
      last.focus({ preventScroll: true });
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus({ preventScroll: true });
    }
  };

  // VO sometimes lands focus outside; pull it back
  const focusinGuard = (e) => {
    if (!isOpen()) return;
    const sb = sidebar();
    if (!sb) return;
    if (!sb.contains(e.target)) requestAnimationFrame(focusInputFallback);
  };

  const bind = () => {
    if (!trapBound) {
      trapBound = true;
      document.addEventListener('keydown', trap, true);
    }
    if (!focusGuardBound) {
      focusGuardBound = true;
      document.addEventListener('focusin', focusinGuard, true);
    }
  };

  const unbind = () => {
    if (trapBound) {
      trapBound = false;
      document.removeEventListener('keydown', trap, true);
    }
    if (focusGuardBound) {
      focusGuardBound = false;
      document.removeEventListener('focusin', focusinGuard, true);
    }
  };

  const onOpen = () => {
    openerEl = openerEl || document.activeElement;

    const sb = sidebar();
    if (sb) {
      sb.setAttribute('role', sb.getAttribute('role') || 'dialog');
      sb.setAttribute('aria-modal', 'true');
    }

    setOutsideHidden(true);
    bind();

    // If we didn't catch the opener gesture, fallback focus (may not open iOS keyboard)
    requestAnimationFrame(() => requestAnimationFrame(focusInputFallback));
  };

  const onClose = () => {
    unbind();
    setOutsideHidden(false);

    if (openerEl && document.contains(openerEl)) {
      requestAnimationFrame(() => openerEl.focus({ preventScroll: true }));
    }
    openerEl = null;
  };

  // 1) BEST: focus within the opener click/keydown (iOS keyboard opens)
  document.addEventListener(
    'click',
    (e) => {
      const opener = e.target.closest(OPENER_SEL);
      if (!opener) return;

      openerEl = opener;

      // Let theme open sidebar, then immediately focus input (still part of user gesture timing)
      setTimeout(() => {
        if (isOpen()) focusInputPreferKeyboard();
      }, 0);
    },
    true
  );

  document.addEventListener(
    'keydown',
    (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const opener = e.target.closest(OPENER_SEL);
      if (!opener) return;

      openerEl = opener;

      setTimeout(() => {
        if (isOpen()) focusInputPreferKeyboard();
      }, 0);
    },
    true
  );

  // 2) Watch body class open/close
  const bodyObs = new MutationObserver(() => {
    if (isOpen()) onOpen();
    else onClose();
  });
  bodyObs.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  if (isOpen()) onOpen();


  // set the focus back to search icon when search bar closed
    const CLOSE_BTN_SEL = '.halo-sidebar-close';
  const RETURN_FOCUS_SEL = '.header-mobile__item--search summary';

  const returnFocus = () => {
    const target = document.querySelector(RETURN_FOCUS_SEL);
    if (target) {
      // Make sure it can receive focus
      if (!target.hasAttribute('tabindex')) {
        target.setAttribute('tabindex', '-1');
      }

      requestAnimationFrame(() => {
        target.focus({ preventScroll: true });
      });
    }
  };

  // Mouse click
  document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest(CLOSE_BTN_SEL);
    if (!closeBtn) return;

    // Wait for sidebar close animation / class removal
    setTimeout(returnFocus, 50);
  }, true);

  // Keyboard (Enter / Space)
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;

    const closeBtn = e.target.closest(CLOSE_BTN_SEL);
    if (!closeBtn) return;

    setTimeout(returnFocus, 50);
  }, true);

})();


/*
* ******************************************************************************************
* fix the issue: “Add to wishlist” button in the product box does not announce any 
                  confirmation or status change when it is activated
* ******************************************************************************************
*/
if (!document.getElementById('wishlist-status-message')) {
    document.body.insertAdjacentHTML(
      'beforeend',
      '<div role="status" id="wishlist-status-message" aria-live="polite" class="visually-hidden"></div>'
    );
}
document.addEventListener('click', e => {
  const btn = e.target.closest('.wishlist-icon');
  if (!btn) return;

  const msg = document.querySelector('#wishlist-status-message');
  if (!msg) return;

  // wait till class toggle completes
  setTimeout(() => {
      msg.innerHTML = btn.classList.contains('wishlist-added')
      ? 'Product added to Wishlist'
      : 'Product removed from Wishlist';
  }, 0);
});

document.addEventListener('click', e => {
  const btn = e.target.closest('.productView-top .single-wish button');
  if (!btn) return;

  const msg = document.querySelector('#wishlist-status-message');
  if (!msg) return;

  // wait till class toggle completes
  setTimeout(() => {
      msg.innerHTML = btn.classList.contains('wishlist-added')
      ? 'Product added to Wishlist'
      : 'Product removed from Wishlist';
  }, 0);
});

/*
* ******************************************************************************************
* fix the issue: “Quick Add button ” button in the product box does not does not 
                 focus on the popup option selection area
* ******************************************************************************************
*/
(() => {
  const BODY_OPEN_CLASS = 'quick_shop_popup_mobile';
  const POPUP_SEL = '#halo-card-mobile-popup';
  const CLOSE_SEL = '.close.close-modal';
  const RETURN_FOCUS_SEL = '.button.button-ATC';

  const FOCUSABLE_SEL = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  let lastTrigger = null;
  let trapActive = false;

  const isOpen = () => document.body.classList.contains(BODY_OPEN_CLASS);

  const isVisible = (el) => {
    if (!el) return false;
    const s = getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden') return false;
    return el.offsetParent !== null || s.position === 'fixed';
  };

  const getFocusable = (root) =>
    [...root.querySelectorAll(FOCUSABLE_SEL)].filter(isVisible);

  const focusFirstInPopup = () => {
    const popup = document.querySelector(POPUP_SEL);
    if (!popup) return;

    const focusables = getFocusable(popup);
    if (focusables.length) {
      focusables[0].focus({ preventScroll: true });
    } else {
      if (!popup.hasAttribute('tabindex')) popup.setAttribute('tabindex', '-1');
      popup.focus({ preventScroll: true });
    }
  };

  const trap = (e) => {
    if (!trapActive || !isOpen() || e.key !== 'Tab') return;

    const popup = document.querySelector(POPUP_SEL);
    if (!popup) return;

    const items = getFocusable(popup);
    if (!items.length) return;

    const first = items[0];
    const last = items[items.length - 1];
    const active = document.activeElement;

    // If focus somehow escapes, bring it back
    if (!popup.contains(active)) {
      e.preventDefault();
      first.focus({ preventScroll: true });
      return;
    }

    // Loop
    if (e.shiftKey && active === first) {
      e.preventDefault();
      last.focus({ preventScroll: true });
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus({ preventScroll: true });
    }
  };

  const focusinGuard = (e) => {
    if (!trapActive || !isOpen()) return;
    const popup = document.querySelector(POPUP_SEL);
    if (!popup) return;

    if (!popup.contains(e.target)) {
      // pull focus back inside popup
      requestAnimationFrame(focusFirstInPopup);
    }
  };

  const enableTrap = () => {
    if (trapActive) return;
    trapActive = true;
    document.addEventListener('keydown', trap, true);
    document.addEventListener('focusin', focusinGuard, true);
  };

  const disableTrap = () => {
    if (!trapActive) return;
    trapActive = false;
    document.removeEventListener('keydown', trap, true);
    document.removeEventListener('focusin', focusinGuard, true);
  };

  // Capture which ATC opened the popup (so we can return focus properly)
  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest(RETURN_FOCUS_SEL);
      if (btn) lastTrigger = btn;
    },
    true
  );

  // Return focus when close clicked (mouse + keyboard)
  const handleCloseActivation = (e) => {
    const closeBtn = e.target.closest(CLOSE_SEL);
    if (!closeBtn) return;

    // Wait for theme to remove body class / hide popup
    setTimeout(() => {
      disableTrap();
      const target = lastTrigger && document.contains(lastTrigger)
        ? lastTrigger
        : document.querySelector(RETURN_FOCUS_SEL);

      if (target) target.focus({ preventScroll: true });
      lastTrigger = null;
    }, 50);
  };

  document.addEventListener('click', handleCloseActivation, true);
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    handleCloseActivation(e);
  }, true);

  // Observe body class change for open/close
  const obs = new MutationObserver(() => {
    if (isOpen()) {
      // popup opened
      enableTrap();
      requestAnimationFrame(() => requestAnimationFrame(focusFirstInPopup));
    } else {
      // popup closed (e.g., overlay click / ESC / theme logic)
      disableTrap();
      if (lastTrigger && document.contains(lastTrigger)) {
        requestAnimationFrame(() => lastTrigger.focus({ preventScroll: true }));
      }
      lastTrigger = null;
    }
  });

  obs.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  // If already open on load
  if (isOpen()) {
    enableTrap();
    requestAnimationFrame(() => requestAnimationFrame(focusFirstInPopup));
  }
})();

/*
* ******************************************************************************************
* fix the issue: focus traping issue for sort by product popup in Mobile device 
* ******************************************************************************************
*/
(() => {
  const BODY_OPEN_CLASS = 'toolbar-modal-open';

  const POPUP_ID = 'shortbymenu';
  const POPUP_SEL = `#${POPUP_ID}`;

  const TRIGGER_SEL = '#sort-popup-trigger-button';
  const CLOSE_BTN_SEL = `${POPUP_SEL} .icon-wrapper`;

  // Sort options are <span>, so we temporarily make them focusable in the modal
  const ITEM_SPAN_SEL = `${POPUP_SEL} [data-sort-by-item] > span.text`;

  const FOCUSABLE_SEL = [
    'button:not([disabled])',
    'a[href]',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
    '[role="button"]'
  ].join(',');

  let trapOn = false;
  let lastInside = null;

  // IMPORTANT: store the *exact* opener element
  let openerEl = null;

  let wasOpen = false;           // tracks previous open state
  let userOpenedThisCycle = false; // only true when trigger was used


  const isOpen = () => document.body.classList.contains(BODY_OPEN_CLASS);
  const getPopup = () => document.querySelector(POPUP_SEL);

  const isVisible = (el) => {
    if (!el) return false;
    const s = getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden') return false;
    return el.offsetParent !== null || s.position === 'fixed';
  };

  const getFocusable = (root) =>
    [...root.querySelectorAll(FOCUSABLE_SEL)].filter(isVisible);

  // Capture which element opened the popup (mouse + keyboard), BEFORE theme changes focus
  const captureOpener = (e) => {
    const t = e.target.closest(TRIGGER_SEL);
    if (!t) return;
    openerEl = t;

    // NEW: popup open was initiated by user interaction with trigger
    userOpenedThisCycle = true;
  };

  document.addEventListener('pointerdown', captureOpener, true);
  document.addEventListener('mousedown', captureOpener, true);
  document.addEventListener('touchstart', captureOpener, true);

  document.addEventListener(
    'keydown',
    (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      captureOpener(e);
    },
    true
  );

  const makeItemsFocusable = () => {
    const popup = getPopup();
    if (!popup) return;

    popup.querySelectorAll(ITEM_SPAN_SEL).forEach((span) => {
      if (!span.hasAttribute('tabindex')) span.setAttribute('tabindex', '0');
      if (!span.hasAttribute('role')) span.setAttribute('role', 'button');
    });
  };

  const cleanupItemsFocusable = () => {
    const popup = getPopup();
    if (!popup) return;

    popup.querySelectorAll(ITEM_SPAN_SEL).forEach((span) => {
      if (span.getAttribute('tabindex') === '0') span.removeAttribute('tabindex');
      if (span.getAttribute('role') === 'button') span.removeAttribute('role');
    });
  };

  const focusFirst = () => {
    const popup = getPopup();
    if (!popup) return;

    makeItemsFocusable();

    const preferred =
      popup.querySelector(ITEM_SPAN_SEL) ||
      getFocusable(popup)[0] ||
      popup;

    if (preferred === popup && !popup.hasAttribute('tabindex')) {
      popup.setAttribute('tabindex', '-1');
    }

    // Helps iOS/VO: delay a tick so element is actually rendered
    setTimeout(() => {
      preferred.focus({ preventScroll: true });
      lastInside = preferred;
    }, 0);
  };

  const ensureTriggerFocusable = (el) => {
    if (!el) return;
    // If it isn't a naturally focusable element, make it focusable
    const tag = el.tagName?.toLowerCase();
    const naturallyFocusable =
      tag === 'button' ||
      tag === 'a' ||
      tag === 'input' ||
      tag === 'select' ||
      tag === 'textarea';

    if (!naturallyFocusable && !el.hasAttribute('tabindex')) {
      el.setAttribute('tabindex', '0');
    }
  };

  const returnFocusToOpener = () => {
    const fallback = document.querySelector(TRIGGER_SEL);

    const target =
      (openerEl && document.contains(openerEl) && isVisible(openerEl) && openerEl) ||
      (fallback && document.contains(fallback) ? fallback : null);

    if (!target) return;

    ensureTriggerFocusable(target);

    // Some themes scroll to top on focus if the element isn't "ready".
    // Delaying + preventScroll keeps it stable.
    setTimeout(() => {
      target.focus({ preventScroll: true });
    }, 0);
  };

  // Tab loop inside popup
  const onKeydown = (e) => {
    if (!trapOn || !isOpen()) return;
    if (e.key !== 'Tab') return;

    const popup = getPopup();
    if (!popup) return;

    const items = getFocusable(popup);
    if (!items.length) {
      e.preventDefault();
      if (!popup.hasAttribute('tabindex')) popup.setAttribute('tabindex', '-1');
      popup.focus({ preventScroll: true });
      lastInside = popup;
      return;
    }

    const first = items[0];
    const last = items[items.length - 1];
    const active = document.activeElement;

    // If focus escaped, pull it back
    if (!popup.contains(active)) {
      e.preventDefault();
      first.focus({ preventScroll: true });
      lastInside = first;
      return;
    }

    if (e.shiftKey && active === first) {
      e.preventDefault();
      last.focus({ preventScroll: true });
      lastInside = last;
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus({ preventScroll: true });
      lastInside = first;
    }
  };

  // Hard guard: focus must not leave popup (important for iOS/VO)
  const onFocusIn = (e) => {
    if (!trapOn || !isOpen()) return;

    const popup = getPopup();
    if (!popup) return;

    if (popup.contains(e.target)) {
      lastInside = e.target;
      return;
    }

    e.stopPropagation();

    const items = getFocusable(popup);
    const fallback =
      (lastInside && popup.contains(lastInside) && isVisible(lastInside) && lastInside) ||
      items[0] ||
      popup;

    if (fallback === popup && !popup.hasAttribute('tabindex')) {
      popup.setAttribute('tabindex', '-1');
    }

    setTimeout(() => fallback.focus({ preventScroll: true }), 0);
  };

  const enableTrap = () => {
    if (trapOn) return;
    trapOn = true;
    document.addEventListener('keydown', onKeydown, true);
    document.addEventListener('focusin', onFocusIn, true);
  };

  const disableTrap = () => {
    if (!trapOn) return;
    trapOn = false;
    lastInside = null;
    document.removeEventListener('keydown', onKeydown, true);
    document.removeEventListener('focusin', onFocusIn, true);
    cleanupItemsFocusable();
  };

  // Close button: after 200ms return focus to opener/trigger
  document.addEventListener(
    'click',
    (e) => {
      const closeBtn = e.target.closest(CLOSE_BTN_SEL);
      if (!closeBtn) return;

      setTimeout(() => {
        // If theme already closed:
        if (!isOpen()) {
          disableTrap();
          returnFocusToOpener();
          return;
        }

        // If theme closes slightly later, wait briefly
        const t = setInterval(() => {
          if (!isOpen()) {
            clearInterval(t);
            disableTrap();
            returnFocusToOpener();
          }
        }, 50);

        setTimeout(() => clearInterval(t), 1500);
      }, 200);
    },
    true
  );

  // Watch open/close by body class
  const obs = new MutationObserver(() => {
    const openNow = isOpen();

    // OPEN transition: closed -> open
    if (openNow && !wasOpen) {
      wasOpen = true;
      enableTrap();
      requestAnimationFrame(() => requestAnimationFrame(focusFirst));
      return;
    }

    // CLOSE transition: open -> closed
    if (!openNow && wasOpen) {
      wasOpen = false;
      disableTrap();

      // Return focus ONLY if it was opened via the trigger
      if (userOpenedThisCycle) {
        setTimeout(() => {
          returnFocusToOpener();
          openerEl = null;
          userOpenedThisCycle = false;
        }, 200);
      } else {
        openerEl = null;
        userOpenedThisCycle = false;
      }
    }
  });


  obs.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  // If already open on load
  if (isOpen()) {
    wasOpen = true; // NEW: so we only treat next change as a close transition
    enableTrap();
    requestAnimationFrame(() => requestAnimationFrame(focusFirst));
  }
})();


/*
* ******************************************************************************************
* fix the issue: focus traping issue for filter by product popup in Mobile device 
* ******************************************************************************************
*/
(function () {
  const TRIGGER_ID = "filter-popup-trigger-button";
  const SIDEBAR_ID = "halo-sidebar";
  const CLOSE_SELECTOR = ".halo-sidebar-close";
  const BODY_OPEN_CLASS = "open-mobile-sidebar";
  const RETURN_FOCUS_DELAY = 200;

  const trigger = document.getElementById(TRIGGER_ID);
  const sidebar = document.getElementById(SIDEBAR_ID);
  if (!trigger || !sidebar) return;

  if (trigger.hasAttribute("autofocus")) trigger.removeAttribute("autofocus");

  let trapActive = false;
  let lastInside = null;
  let topSentinel = null;
  let bottomSentinel = null;

  const FOCUSABLE_SEL = [
    'a[href]:not([tabindex="-1"])',
    'button:not([disabled]):not([tabindex="-1"])',
    'input:not([disabled]):not([type="hidden"]):not([tabindex="-1"])',
    'select:not([disabled]):not([tabindex="-1"])',
    'textarea:not([disabled]):not([tabindex="-1"])',
    '[role="button"]:not([tabindex="-1"])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(",");

  const isOpen = () => document.body.classList.contains(BODY_OPEN_CLASS);

  function isVisible(el) {
    if (!el) return false;
    const s = getComputedStyle(el);
    if (s.display === "none" || s.visibility === "hidden") return false;
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function getFocusable(root) {
    return Array.from(root.querySelectorAll(FOCUSABLE_SEL))
      .filter(isVisible)
      .filter(el => el !== sidebar && el !== topSentinel && el !== bottomSentinel);
  }

  function ensureSentinels() {
    if (topSentinel && bottomSentinel) return;

    topSentinel = document.createElement("span");
    bottomSentinel = document.createElement("span");

    [topSentinel, bottomSentinel].forEach(s => {
      s.tabIndex = 0;
      s.setAttribute("aria-hidden", "true");
      s.style.cssText =
        "position:fixed;width:1px;height:1px;padding:0;margin:-1px;" +
        "overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;";
    });

    sidebar.prepend(topSentinel);
    sidebar.append(bottomSentinel);

    topSentinel.addEventListener("focus", () => {
      if (!trapActive || !isOpen()) return;
      const items = getFocusable(sidebar);
      if (items.length) {
        items[items.length - 1].focus({ preventScroll: true });
        lastInside = items[items.length - 1];
      }
    });

    bottomSentinel.addEventListener("focus", () => {
      if (!trapActive || !isOpen()) return;
      const items = getFocusable(sidebar);
      if (items.length) {
        items[0].focus({ preventScroll: true });
        lastInside = items[0];
      }
    });
  }

  function removeSentinels() {
    if (topSentinel) topSentinel.remove();
    if (bottomSentinel) bottomSentinel.remove();
    topSentinel = null;
    bottomSentinel = null;
  }

  function focusFirst() {
    const items = getFocusable(sidebar);
    if (items.length) {
      items[0].focus({ preventScroll: true });
      lastInside = items[0];
    } else {
      sidebar.setAttribute("tabindex", "-1");
      sidebar.focus({ preventScroll: true });
      lastInside = sidebar;
    }
  }

  function focusLast() {
    const items = getFocusable(sidebar);
    if (items.length) {
      items[items.length - 1].focus({ preventScroll: true });
      lastInside = items[items.length - 1];
    } else {
      sidebar.setAttribute("tabindex", "-1");
      sidebar.focus({ preventScroll: true });
      lastInside = sidebar;
    }
  }

  function restoreInside() {
    const items = getFocusable(sidebar);
    const fallback = items[0] || sidebar;

    const target =
      (lastInside && sidebar.contains(lastInside) && isVisible(lastInside) && lastInside) ||
      fallback;

    if (target === sidebar && !sidebar.hasAttribute("tabindex")) sidebar.setAttribute("tabindex", "-1");

    // double rAF helps when sidebar is animated
    requestAnimationFrame(() => requestAnimationFrame(() => {
      target.focus({ preventScroll: true });
    }));
  }

  function onKeyDown(e) {
    if (!trapActive || !isOpen()) return;

    if (e.key === "Tab") {
      const items = getFocusable(sidebar);
      if (!items.length) {
        e.preventDefault();
        sidebar.setAttribute("tabindex", "-1");
        sidebar.focus({ preventScroll: true });
        return;
      }

      const first = items[0];
      const last = items[items.length - 1];
      const active = document.activeElement;

      // If focus somehow escaped, bring it back
      if (!sidebar.contains(active)) {
        e.preventDefault();
        first.focus({ preventScroll: true });
        lastInside = first;
        return;
      }

      // Wrap at ends
      if (!e.shiftKey && active === last) {
        e.preventDefault();
        first.focus({ preventScroll: true });
        lastInside = first;
        return;
      }

      if (e.shiftKey && active === first) {
        e.preventDefault();
        last.focus({ preventScroll: true });
        lastInside = last;
        return;
      }
    }

    if (e.key === "Escape") {
      e.preventDefault();
      closeSidebar();
    }
  }

  // HARD GUARD: focus can never leave sidebar while open
  function onFocusIn(e) {
    if (!trapActive || !isOpen()) return;

    if (sidebar.contains(e.target)) {
      lastInside = e.target;
      return;
    }

    // Block + restore inside
    e.preventDefault?.();
    e.stopPropagation();
    restoreInside();
  }

  // HARD GUARD: prevent click/touch focusing outside
  function onPointerDown(e) {
    if (!trapActive || !isOpen()) return;

    if (sidebar.contains(e.target)) return;

    e.preventDefault();
    e.stopPropagation();
    restoreInside();
  }

  function openSidebar() {
    document.body.classList.add(BODY_OPEN_CLASS);

    trapActive = true;
    lastInside = null;
    ensureSentinels();

    document.addEventListener("keydown", onKeyDown, true);
    document.addEventListener("focusin", onFocusIn, true);
    document.addEventListener("pointerdown", onPointerDown, true);
    document.addEventListener("mousedown", onPointerDown, true);
    document.addEventListener("touchstart", onPointerDown, true);

    // focus after open
    requestAnimationFrame(() => requestAnimationFrame(focusFirst));
  }

  function closeSidebar() {
    document.body.classList.remove(BODY_OPEN_CLASS);

    trapActive = false;
    lastInside = null;

    document.removeEventListener("keydown", onKeyDown, true);
    document.removeEventListener("focusin", onFocusIn, true);
    document.removeEventListener("pointerdown", onPointerDown, true);
    document.removeEventListener("mousedown", onPointerDown, true);
    document.removeEventListener("touchstart", onPointerDown, true);

    removeSentinels();

    window.setTimeout(() => {
      const t = document.getElementById(TRIGGER_ID);
      if (t) t.focus({ preventScroll: true });
    }, RETURN_FOCUS_DELAY);
  }

  // open on trigger click
  trigger.addEventListener("click", (e) => {
    e.preventDefault();
    openSidebar();
  });

  // close button
  sidebar.addEventListener("click", (e) => {
    const btn = e.target.closest(CLOSE_SELECTOR);
    if (!btn) return;
    e.preventDefault();
    closeSidebar();
  });

  // If theme toggles class itself, sync trap state
  const mo = new MutationObserver(() => {
    if (isOpen() && !trapActive) openSidebar();
    if (!isOpen() && trapActive) closeSidebar();
  });
  mo.observe(document.body, { attributes: true, attributeFilter: ["class"] });

})();


/*
* ******************************************************************************************
* fix the issue: Sort by loader and result Announcement for screen reader
* ******************************************************************************************
*/
if (!document.getElementById('sort-status-message')) {
    document.body.insertAdjacentHTML(
      'beforeend',
      '<div role="status" id="sort-status-message" aria-live="assertive" class="visually-hidden"></div>'
    );
}

document.addEventListener("DOMContentLoaded", function () {
    const body = document.body;
    const statusDiv = document.getElementById("sort-status-message");

    if (!statusDiv) return;

    let hadToolbarModalOpen = body.classList.contains("toolbar-modal-open");
    let hadHaloLoader = body.classList.contains("has-halo-loader");

    const observer = new MutationObserver(() => {
        const hasToolbarModalOpen = body.classList.contains("toolbar-modal-open");
        const hasHaloLoader = body.classList.contains("has-halo-loader");

        // ✅ Condition 1:
        // toolbar-modal-open REMOVED + has-halo-loader ADDED
        if (
            hadToolbarModalOpen &&
            !hasToolbarModalOpen &&
            !hadHaloLoader &&
            hasHaloLoader
        ) {
            statusDiv.textContent = "Loading";
        }

        // ✅ Condition 2:
        // has-halo-loader REMOVED
        if (hadHaloLoader && !hasHaloLoader) {
            statusDiv.textContent = "Product sorted";
        }

        // Update previous states
        hadToolbarModalOpen = hasToolbarModalOpen;
        hadHaloLoader = hasHaloLoader;
    });

    observer.observe(body, {
        attributes: true,
        attributeFilter: ["class"]
    });
});

/**
 * *********************************************************************************************************
 * fix the issue: confirmation or status message is announced by screen readers
 * *********************************************************************************************************
 */
// 1) Live region (must NOT be display:none)
function ensureLiveRegion() {
  let live = document.getElementById("cart-status-message");
  if (!live) {
    document.body.insertAdjacentHTML(
      "beforeend",
      `<div id="cart-status-message"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            class="visually-hidden"></div>`
    );
    live = document.getElementById("cart-status-message");
  }
  return live;
}

const liveRegion = ensureLiveRegion();

const announce = (msg, delay = 80) => {
  liveRegion.textContent = "";
  setTimeout(() => {
    liveRegion.textContent = msg;
  }, delay);
};

const getFirstFocusable = (container) =>
  container?.querySelector(
    'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
  );

// 2) Capture item label on remove click
let pendingRemovedLabel = null;

document.addEventListener(
  "click",
  (e) => {
    const removeLink = e.target.closest("a.cart-remove");
    if (!removeLink) return;

    const lineItem =
      removeLink.closest("[data-cart-item], .cart-item, li") ||
      removeLink.parentElement;

    const titleEl =
      lineItem?.querySelector(
        ".cart-item__title, .cart-item__name, a[href*='/products/']"
      );

    pendingRemovedLabel = titleEl?.textContent?.trim() || "item";
  },
  true
);

// 3) Observe BODY for cart changes (wrapper may be replaced)
let emptyHandled = false;
let lastRemoveCount = document.querySelectorAll("a.cart-remove").length;

const bodyObserver = new MutationObserver(() => {
  const removeCount = document.querySelectorAll("a.cart-remove").length;

  // 🔔 Item removed (but cart not empty yet)
  if (removeCount < lastRemoveCount && removeCount > 0) {
    announce(`Removed ${pendingRemovedLabel || "item"} from cart.`, 80);
    pendingRemovedLabel = null;
  }

  // 🛒 Cart empty state appeared
  const emptyEl = document.querySelector(".cart-content-empty");

  if (emptyEl && !emptyHandled) {
    // Announce after DOM settles
    announce("Your cart is now empty.", 300);

    // Move focus after announcement starts
    setTimeout(() => {
      const focusTarget =
        getFirstFocusable(emptyEl) || emptyEl;

      if (
        focusTarget === emptyEl &&
        !emptyEl.hasAttribute("tabindex")
      ) {
        emptyEl.setAttribute("tabindex", "-1");
      }

      focusTarget.focus({ preventScroll: false });
      focusTarget.scrollIntoView({ behavior: "smooth", block: "start" });

      emptyHandled = true;
    }, 500);
  }

  // Reset if cart becomes non-empty again
  if (!emptyEl) emptyHandled = false;

  lastRemoveCount = removeCount;
});

bodyObserver.observe(document.body, {
  childList: true,
  subtree: true
});

/**
 * ********************************************************************
 * fix the issue: Set focus to cart side bar when product added to cart
 * ********************************************************************
 **/
(function () {
  const BODY_OPEN_CLASS = "cart-sidebar-show";
  const SIDEBAR_SELECTOR = "#halo-cart-sidebar";

  // Triggers that can open the cart sidebar
  const TRIGGER_SELECTORS = [
    "button.product-form__submit.button.button--secondary.an-", // add to cart
    ".header__icon--cart",
    "#product-add-to-cart"                                      // cart icon link/button
  ];

  // Set this to your main page wrapper (everything except the sidebar).
  // Common Shopify: "main, #MainContent"
  const PAGE_WRAPPER_SELECTOR = "main, #MainContent";

  const FOCUSABLE_SELECTOR = [
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "input:not([disabled]):not([type='hidden'])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "[contenteditable='true']",
    "[tabindex]:not([tabindex='-1'])"
  ].join(",");

  let isTrapping = false;
  let lastTriggerEl = null;
  let wasOpen = document.body.classList.contains(BODY_OPEN_CLASS);

  const getSidebar = () => document.querySelector(SIDEBAR_SELECTOR);

  const isVisible = (el) =>
    !!el && !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);

  const getFocusable = (container) => {
    if (!container) return [];
    return Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter(isVisible);
  };

  // Everything outside the sidebar we want to "disable" when modal is open
  const getPageWrappers = () => {
    const sidebar = getSidebar();
    const wrappers = Array.from(document.querySelectorAll(PAGE_WRAPPER_SELECTOR)).filter(Boolean);

    // Fallback if selector doesn't match: all body children except sidebar
    if (!wrappers.length) {
      return Array.from(document.body.children).filter((el) => el !== sidebar);
    }
    return wrappers.filter((el) => el !== sidebar);
  };

  const setModalSemantics = (open) => {
    const sidebar = getSidebar();
    if (!sidebar) return;

    if (open) {
      sidebar.setAttribute("role", "dialog");
      sidebar.setAttribute("aria-modal", "true");
      // Optional: sidebar.setAttribute("aria-label", "Cart");
    } else {
      sidebar.removeAttribute("aria-modal");
      // Keep role if your theme relies on it; remove if you prefer:
      // sidebar.removeAttribute("role");
    }
  };

  const setBackgroundDisabled = (disabled) => {
    const wrappers = getPageWrappers();
    wrappers.forEach((el) => {
      if (!el) return;

      if (disabled) {
        if ("inert" in el) {
          el.inert = true;
        } else {
          el.setAttribute("aria-hidden", "true");
        }
      } else {
        if ("inert" in el) {
          el.inert = false;
        } else {
          el.removeAttribute("aria-hidden");
        }
      }
    });
  };

  const focusFirstInSidebar = () => {
    const sidebar = getSidebar();
    if (!sidebar) return;

    if (!sidebar.hasAttribute("tabindex")) sidebar.setAttribute("tabindex", "-1");

    // Prefer a close button if present
    const closeBtn =
      sidebar.querySelector("[data-close-cart], .halo-sidebar-close, .close, button[aria-label*='Close']") ||
      null;

    const focusables = getFocusable(sidebar);
    const target = closeBtn || focusables[0] || sidebar;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        try {
          target.focus({ preventScroll: false });
        } catch (e) {
          target.focus();
        }
      });
    });
  };

  // Keyboard Tab trap (helps non-VO keyboard users)
  const trapKeydown = (e) => {
    if (!isTrapping || e.key !== "Tab") return;

    const sidebar = getSidebar();
    if (!sidebar) return;

    const focusables = getFocusable(sidebar);
    if (!focusables.length) {
      e.preventDefault();
      sidebar.focus();
      return;
    }

    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    const active = document.activeElement;

    if (!sidebar.contains(active)) {
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
      return;
    }

    if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus();
    } else if (e.shiftKey && active === first) {
      e.preventDefault();
      last.focus();
    }
  };

  const enforceFocusInside = (e) => {
    if (!isTrapping) return;

    const sidebar = getSidebar();
    if (!sidebar) return;

    if (document.body.classList.contains(BODY_OPEN_CLASS) && !sidebar.contains(e.target)) {
      const focusables = getFocusable(sidebar);
      (focusables[0] || sidebar).focus();
    }
  };

  const enableTrap = () => {
    if (isTrapping) return;
    isTrapping = true;

    setModalSemantics(true);
    setBackgroundDisabled(true);

    document.addEventListener("keydown", trapKeydown, true);
    document.addEventListener("focusin", enforceFocusInside, true);

    focusFirstInSidebar();
  };

  const restoreFocusToTrigger = () => {
    if (!lastTriggerEl) return;

    // VoiceOver/iOS often needs a longer delay after DOM updates
    setTimeout(() => {
      if (lastTriggerEl && document.documentElement.contains(lastTriggerEl)) {
        try {
          lastTriggerEl.focus({ preventScroll: false });
        } catch (e) {
          lastTriggerEl.focus();
        }
      }
      lastTriggerEl = null;
    }, 400);
  };

  const disableTrap = () => {
    if (!isTrapping) return;
    isTrapping = false;

    document.removeEventListener("keydown", trapKeydown, true);
    document.removeEventListener("focusin", enforceFocusInside, true);

    setBackgroundDisabled(false);
    setModalSemantics(false);

    restoreFocusToTrigger();
  };

  // Capture the element that opened the sidebar (Add-to-cart OR cart icon)
  document.addEventListener(
    "click",
    (e) => {
      const selector = TRIGGER_SELECTORS.join(",");
      const trigger = e.target.closest(selector);
      if (trigger) lastTriggerEl = trigger;
    },
    true
  );

  // Observe open/close via body class changes
  const bodyObserver = new MutationObserver(() => {
    const isOpen = document.body.classList.contains(BODY_OPEN_CLASS);

    if (!wasOpen && isOpen) enableTrap();
    if (wasOpen && !isOpen) disableTrap();

    wasOpen = isOpen;
  });

  bodyObserver.observe(document.body, { attributes: true, attributeFilter: ["class"] });

  // Initial state
  if (wasOpen) enableTrap();
})();
